// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__dNOWc","cta":"Footer_cta__na6Sp","meta":"Footer_meta__cysl6","brand":"Footer_brand__y+vAl","copy":"Footer_copy__5JOuj"};